import {FilterData, Data} from '../common/data'
export const CooperationMember = {
    namespaced: true,
    state:{
        api: {
            main:'/api/pedagog/members'
        },
        items: false
    },
    mutations: {
        setItems(state, value){
            state.items = value
        }
    },
    getters:{
        ...FilterData.getters
    },
    actions: {
        ...Data.actions
    }
}

export const CooperationPartner = {
    namespaced: true,
    state: {
        api: {
            main: '/api/pedagog/partners'
        },
        items: false
    },
    mutations: {
        setItems(state, value){
            state.items = value
        }
    },
    getters:{
        ...FilterData.getters
    },
    actions: {
        ...Data.actions
    }
}

export const CooperationProf = {
    namespaced: true,
    state: {
        api: {
            main: '/api/pedagog/profs',
        },
        items: false,
    },
    mutations: {
        setItems(state, value){
            state.items = value
        }
    },
    getters:{
        ...FilterData.getters
    },
    actions: {
        ...Data.actions
    }
}
